






























































































import { Mixins, Component, Ref } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import VContentLoading from "@/components/VContentLoading.vue";
import ClientsShowTabs from "./Tabs.vue";
import { currentUserStore } from "@/store/typed";
import { Client, Company, Quotation } from "@/models";
import QuotationsMixin from "@/mixins/http/QuotationsMixin";
import ClientsMixin from "@/mixins/http/ClientsMixin";
import { NoCache, RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import Filters from "@/components/Quotation/Filters.vue";
import Search from "@/components/VEntrySearch.vue";
import StatusBadge from "@/components/Quotation/StatusBadge.vue";
import QuotationTable from "@/components/Quotation/QuotationTable.vue";

const GET_QUOTATIONS_TAG = "get_quotations_tag";
const GET_CLIENT_TAG = "get_client_tag";

@Component({
  components: {
    Page,
    VContentLoading,
    ClientsShowTabs,
    Filters,
    Search,
    StatusBadge,
    QuotationTable,
  },
})
export default class Quotations extends Mixins(QuotationsMixin, ClientsMixin) {
  company: Company = currentUserStore.company;
  @RegisterHttp(GET_QUOTATIONS_TAG) readonly quotationRequest: RequestData;
  @RegisterHttp(GET_CLIENT_TAG) readonly clientRequest: RequestData;

  private items: Quotation[] = [];
  private search: string = null;
  private client: Client = null;

  private showFilters = false;
  page = 1;
  private filter = null;

  @Ref() readonly quotationTable!: QuotationTable;

  onReset() {
    this.page = 1;
    this.$router.replace({ query: {} }).catch(() => {});
    this.filter = null;
    this.loadQuotations();
  }

  async loadQuotations() {
    this.items = await this.getQuotations(this.payload, GET_QUOTATIONS_TAG);
  }

  @NoCache
  get payload() {
    const data: any = {
      page: this.page,
      companyId: this.company?.id,
      filter: Object.assign({}, { client: this.clientId }, this.filter),
    };

    if (this.search) {
      data.filter.term = this.search;
    }
    return data;
  }

  get clientId() {
    return this.$route.params.id;
  }

  get loading() {
    return this.quotationRequest?.loading || this.clientRequest?.loading;
  }

  get meta() {
    return this.quotationRequest?.meta;
  }
  get statuses() {
    return Quotation.statuses;
  }

  get hasFilters() {
    return !!(Object.keys(this.filter || {}).length > 1 || this.search);
  }

  async mounted() {
    await this.loadClient();
  }

  onPageChange(page) {
    this.page = page;
    this.loadQuotations();
  }
  onCreated(item: Quotation) {
    this.items.unshift(item);
    this.openDetail(item, true);
  }

  onUpdated(item: Quotation) {
    const index = this.items.findIndex((o) => item.id === o.id);
    this.$set(this.items, index, item);
  }

  openDetail(item: Quotation, edit: boolean) {
    this.$router.push({
      name: "quotation_edit",
      params: { id: item.id },
      query: { edit: edit ? "1" : "0" },
    });
  }

  async searchQuotations(name: string) {
    if (name.trim().length > 0) {
      this.search = name;
      const products = await this.getQuotations(
        this.payload,
        GET_QUOTATIONS_TAG
      );
      return products;
    }
  }
  onSearchCanceled() {
    this.page = 1;
    this.search = null;
    this.loadQuotations();
  }
  onSearched(items) {
    this.page = 1;
    this.items = items.items;
  }

  applyFilters(value) {
    this.page = 1;
    if (!this.filter) {
      this.filter = {};
    }
    if (value.filter) {
      Object.assign(this.filter, value.filter);
    }
    this.$router.replace({ query: { ...this.filter } }).catch(() => {});
    this.loadQuotations();
  }
  openCreateQuotation() {
    this.quotationTable.openCreateModal();
  }

  async loadClient() {
    this.client = await this.getClient(
      this.$route.params.id,
      this.company.id,
      GET_CLIENT_TAG
    );
  }
}
